import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/notifications/List'
import Form from 'containers/pages/notifications/Form'

const Notification = ({ location, match, currentUser }) => {
  if (location.pathname === '/notification') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-notification-announcement-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-notification-announcement-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

Notification.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Notification
